import { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

export const searchInputSelector = (
  state: SpartacuxProductDiscoveryDomainState,
): string | undefined =>
  state.productDiscovery?.headerLeonidas?.ui.search?.input;
